var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-container"},[_c('ydl-titleheader',{attrs:{"color":"blue"}},[_vm._v("Calendar")]),_vm._v(" "),_c('calendar-view',{attrs:{"show-date":_vm.showDate,"events":_vm.events,"theme-default":"","holiday-us-traditional":"","holiday-us-official":""},on:{"show-date-change":_vm.setShowDate}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eacbb8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeacherCalendar.vue
// module id = null
// module chunks = 